import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceHealthTable = ({ services }) => {
  const getStatusColor = (status) => {
    const colors = {
      operational: 'text-success',
      degraded: 'text-warning',
      outage: 'text-error'
    };
    return colors?.[status] || 'text-muted-foreground';
  };

  const getStatusIcon = (status) => {
    const icons = {
      operational: 'CheckCircle2',
      degraded: 'AlertTriangle',
      outage: 'XCircle'
    };
    return icons?.[status] || 'Info';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center gap-3 mb-4">
        <Icon name="Server" size={24} className="text-primary" />
        <h4 className="text-base font-semibold">Service Health Status</h4>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-2 text-sm font-medium text-muted-foreground">Service</th>
              <th className="text-left py-3 px-2 text-sm font-medium text-muted-foreground">Status</th>
              <th className="text-left py-3 px-2 text-sm font-medium text-muted-foreground">Uptime</th>
              <th className="text-left py-3 px-2 text-sm font-medium text-muted-foreground">Response</th>
              <th className="text-left py-3 px-2 text-sm font-medium text-muted-foreground">Last Incident</th>
            </tr>
          </thead>
          <tbody>
            {services?.map((service, index) => (
              <tr key={index} className="border-b border-border last:border-0">
                <td className="py-3 px-2 text-sm font-medium">{service?.service}</td>
                <td className="py-3 px-2">
                  <div className="flex items-center gap-2">
                    <Icon
                      name={getStatusIcon(service?.status)}
                      size={16}
                      className={getStatusColor(service?.status)}
                    />
                    <span className={`text-sm capitalize ${getStatusColor(service?.status)}`}>
                      {service?.status}
                    </span>
                  </div>
                </td>
                <td className="py-3 px-2 text-sm">{service?.uptime}</td>
                <td className="py-3 px-2 text-sm">{service?.responseTime}</td>
                <td className="py-3 px-2 text-sm text-muted-foreground">{service?.lastIncident}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ServiceHealthTable;